export default __webpack_public_path__ + "static/enspire_program-212cc68304cdc4dce0b029476a5a906d.svg";